import { render, staticRenderFns } from "./spotGoodsForm.vue?vue&type=template&id=4ad5ec2a&scoped=true"
import script from "./spotGoodsForm.vue?vue&type=script&lang=js"
export * from "./spotGoodsForm.vue?vue&type=script&lang=js"
import style0 from "./spotGoodsForm.vue?vue&type=style&index=0&id=4ad5ec2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad5ec2a",
  null
  
)

export default component.exports